
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M2.80999 2.81002C2.41999 2.42002 1.78999 2.42002 1.39999 2.81002C0.999986 3.20002 0.999986 3.83002 1.38999 4.22002L9.57999 12.41L6.57999 15.42C6.20999 15.8 5.99999 16.31 5.99999 16.84V20C5.99999 21.1 6.89999 22 7.99999 22H16C16.86 22 17.58 21.46 17.87 20.7L19.78 22.61C20.17 23 20.8 23 21.19 22.61C21.58 22.22 21.58 21.59 21.19 21.2L2.80999 2.81002ZM16 19C16 19.55 15.55 20 15 20H8.99999C8.44999 20 7.99999 19.55 7.99999 19V16.5L10.84 13.66L16 18.83V19Z' fill='#323232'/><path d='M7.99997 5C7.99997 4.45 8.44997 4 8.99997 4H15C15.55 4 16 4.45 16 5V7.5L13.16 10.34L14.41 11.59L17.41 8.6C17.79 8.22 18 7.71 18 7.18V4C18 2.89 17.1 2 16 2H7.99997C7.13997 2 6.41997 2.54 6.12997 3.3L7.99997 5.17V5Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-hourglass-disabled`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconHourglassDisabled

    ```js
    <b-new-b-icon-hourglass-disabled />
    ```
</docs>


